// 原生的text不支持点赞操作，因此全部转为card模式下的富文本，形态和text没有区别
import "./index.less"
import { useMsgStore } from "@/hooks/useStore"

function HasManualStoppedCard({ msg, chatInstance }) {
  const manualStoppedMsgIds = useMsgStore((state) => state.manualStoppedMsgIds)
  return manualStoppedMsgIds.includes(msg.qId) ? (
    <div className='has-manual-stopped'>
      <div className='msg-line' style={{ marginBottom: 0 }}>
        已停止生成
      </div>
    </div>
  ) : (
    <></>
  )
}

export default HasManualStoppedCard
